export default "__VITE_ASSET__100c5028__"